module.exports = __webpack_public_path__ + "static/media/ac.80600245.jpg";